import { Checkbox } from 'antd'
import type { FC } from 'react'
import { useCallback } from 'react'

import { QueryKeyENUM } from '../../atoms/Filters/ApplyFilters.model'
import type { IDefaultFilterProps } from '../0_FilteraCollection/Filters.model'
import { SFilterBlock, STitle } from '../Filters.styled'

const filterPaymentFromPFDO = 3 // Оплата в рамках системы ПФДО

export const ServicesInSocialSphere: FC<IDefaultFilterProps> = ({
  setFilters,
  prevState,
}) => {
  const handleOnChange = useCallback(() => {
    if (!prevState?.value)
      setFilters(QueryKeyENUM.kind, { value: filterPaymentFromPFDO })
    else setFilters(QueryKeyENUM.kind, null)
  }, [prevState?.value, setFilters])

  return (
    <SFilterBlock>
      <STitle>
        Реестр государственных (муниципальных) услуг в социальной сфере
      </STitle>
      <Checkbox checked={!!prevState?.value} onChange={handleOnChange} />
    </SFilterBlock>
  )
}
